export enum FilterItemTypes{
  sus_conversionDropdownVisibilityType=0,
  sus_unit_default_value=1,
}
